module.exports = __webpack_public_path__ + "img/building.d23fdd8d.png";